// Цветовая палитра проекта
export const COLORS = {
  kubes: "#928279",
  surfaceElements: "#cbb9af",
  wood: "#634a2c",
  yellow: "#8A7F00",
  orange: "#8A4900",
  red: "#4F2729",
  green: "#2F4F42",
  goButton: "#1E90FF",
  background: "#89BB85",
};
